var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-editor',{ref:"editor",attrs:{"id":"editor-mention","editorOptions":_vm.editorSettings},on:{"input":_vm.handleInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }